/**
 * useKeyboardShortcut Hook
 * Simple keyboard shortcut handler
 */

import { useEffect } from 'react';

export function useKeyboardShortcut(key, callback, options = {}) {
  const {
    ctrl = false,
    shift = false,
    alt = false,
    meta = false,
    enabled = true,
    preventDefault = false
  } = options;

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      const matchesModifiers =
        event.ctrlKey === ctrl &&
        event.shiftKey === shift &&
        event.altKey === alt &&
        event.metaKey === meta;

      const matchesKey = event.key.toLowerCase() === key.toLowerCase();

      if (matchesModifiers && matchesKey) {
        if (preventDefault) {
          event.preventDefault();
        }
        callback(event);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [key, callback, ctrl, shift, alt, meta, enabled, preventDefault]);
}

export default useKeyboardShortcut;

export function getShortcutDisplay(key, options = {}) {
  const { ctrl = false, shift = false, alt = false, meta = false } = options;
  const parts = [];
  
  if (ctrl || meta) parts.push(navigator.platform.includes("Mac") ? "⌘" : "Ctrl");
  if (shift) parts.push("⇧");
  if (alt) parts.push("⌥");
  parts.push(key.toUpperCase());
  
  return parts.join("+");
}

